import { delay, iconClassName, styles, svgProps } from '@/components/service-showcase/icons/shared';
import type { IServiceShowcaseSvgIconProps } from '@/components/service-showcase/icons/type';

// 4 ascending bars with rounded caps, topped by a rising trend line
const BARS = [
  { x: 95, yTop: 158, d: 0.1 },
  { x: 158, yTop: 130, d: 0.22 },
  { x: 221, yTop: 96, d: 0.34 },
  { x: 284, yTop: 56, d: 0.46 },
];

const BASELINE_Y = 190;

export default function OperationalLiftIcon(props: IServiceShowcaseSvgIconProps) {
  const { active = true, className, ...rest } = props;

  return (
    <svg {...svgProps} {...rest} className={iconClassName(active, className)}>
      {/* Baseline */}
      <line x1='55' y1={BASELINE_Y} x2='330' y2={BASELINE_Y} stroke='currentColor' strokeOpacity='0.18' strokeWidth='1.2' />

      {/* Rising bars */}
      {BARS.map(({ x, yTop, d }) => (
        <line
          key={x}
          x1={x} y1={BASELINE_Y} x2={x} y2={yTop}
          stroke='currentColor' strokeOpacity='0.22' strokeWidth='18' strokeLinecap='round'
          className={styles.pop} style={delay(`${d}s`)}
        />
      ))}

      {/* Trend line drawn over bars */}
      <polyline
        points={BARS.map(({ x, yTop }) => `${x},${yTop}`).join(' ')}
        stroke='currentColor' strokeWidth='2' strokeOpacity='0.88'
        fill='none' pathLength='1'
        className={styles.link} style={delay('0.6s')}
      />

      {/* Peak node */}
      <circle
        cx={BARS[3].x} cy={BARS[3].yTop} r={6}
        fill='currentColor' fillOpacity='0.9'
        className={styles.pop} style={delay('0.9s')}
      />

      {/* Expanding pulse on peak */}
      <circle
        cx={BARS[3].x} cy={BARS[3].yTop} r={12}
        stroke='currentColor' strokeOpacity='0.4' fill='none'
        className={styles.sourcePulse}
        style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
      />

      <text x='292' y='48' fill='currentColor' fillOpacity='0.35' fontSize='8' fontFamily='monospace' letterSpacing='0.1em'>+ EFFICIENCY</text>
    </svg>
  );
}
